module.exports = __webpack_public_path__ + "static/media/STR-LP.515fc212.png";